import { richTextToPlainText } from './html-text';

/** Decodes HTML entities so TipTap can render stored rich-text attributes. */
export const normalizeRichTextHtml = (
  value: string | null | undefined,
): string => {
  if (!value) {
    return '';
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
};

const replaceLegacyInlineMathSpans = (wrapper: HTMLElement): void => {
  wrapper.querySelectorAll<HTMLElement>('[data-latex]').forEach((element) => {
    const latex = element.dataset.latex;
    if (!latex) {
      element.remove();
      return;
    }

    element.replaceWith(document.createTextNode(`$$${latex}$$`));
  });
};

/** Converts legacy inline-math spans to $$ markers for TipTap rendering. */
export const prepareRichTextHtmlForDisplay = (
  value: string | null | undefined,
): string => {
  if (!value) {
    return '';
  }

  const wrapper = document.createElement('div');
  wrapper.innerHTML = normalizeRichTextHtml(value);
  replaceLegacyInlineMathSpans(wrapper);

  return wrapper.innerHTML;
};

export const getRichTextPlainText = (
  value: string | null | undefined,
): string => {
  return richTextToPlainText(normalizeRichTextHtml(value));
};

/** Plain text for tooltips: strips inline math markers after rich-text extraction. */
export const getTooltipPlainText = (value: string | null | undefined): string =>
  getRichTextPlainText(value)
    .replace(/\$\$[\s\S]*?\$\$/g, '')
    .replace(/\s+/g, ' ')
    .trim();

export const hasRichTextContent = (
  value: string | null | undefined,
): boolean => {
  return getRichTextPlainText(value).length > 0;
};
